import React, {useContext, useState} from 'react';
import {userIdAndToken, userIdAndTokenByFacebook} from '../../api/skyduck'
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import FacebookLogin from 'react-facebook-login';
import Row from "react-bootstrap/Row";
import {LoggedInContext} from "../../index";
import * as ReactGA from "react-ga";

function LoginScreen(props) {
    ReactGA.pageview('/login');

    let loggedInContext = useContext(LoggedInContext);

    const [loading, setLoading] = useState(false);

    const username = useFormInput('');
    const password = useFormInput('');

    const [error, setError] = useState(null);

    const handleLogin = async (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        setValidated(true);

        if (username.value && password.value) {
            setError(null);
            setLoading(true);

            try {
                await userIdAndToken(username.value.toLowerCase(), password.value);
                props.history.push('/');
                loggedInContext.toggleLoggedIn();
            } catch (error) {
                setError(error);
                setValidated(false);
                setLoading(false);
            }
        }
    }

    const [validated, setValidated] = useState(false);

    const handleFacebookLogin = async (response) => {
        setError(null);
        try {
            if(response.accessToken) {
                await userIdAndTokenByFacebook(response.email, response.accessToken);
                props.history.push('/');
                loggedInContext.toggleLoggedIn();
            } else {
                throw Error("Unable to sign in with Facebook. Please try again later or enter using your E-mail.");
            }
        } catch (error) {
            setError(error);
        }
    }

    return (
        <div className="container-fluid vertical-filler d-flex justify-content-center background-image">
            <div className="row w-100 justify-content-center align-self-center">
                <Col xs={12} sm={8} md={7} lg={5} xl={4}>
                    <Card className="shadow rounded login-card-body">
                        <Card.Body>
                            <Form noValidate validated={validated} onSubmit={handleLogin}>
                                <p className="skyduck-color input-label mb-0">E-mail</p>

                                <Form.Control
                                    type="text"
                                    {...username}
                                    required
                                    className="input-no-border"/>
                                <Form.Control.Feedback type="invalid">
                                    Please enter login
                                </Form.Control.Feedback>

                                <hr className="mt-2 mb-2"/>

                                <p className="skyduck-color input-label mb-0">Password</p>

                                <Form.Control
                                    type="password"
                                    {...password}
                                    required
                                    className="input-no-border"/>
                                <Form.Control.Feedback type="invalid">
                                    Please enter password
                                </Form.Control.Feedback>
                                
                                <hr className="mt-2 mb-2"/>

                                <Row className="mt-3 justify-content-between">
                                    <Col xs="auto" sm="auto" md="auto" lg="auto" xl="auto">
                                        <Button type="submit" variant="primary" onClick={handleLogin} disabled={loading}>
                                            {loading ? 'Loading...' : 'Login'}
                                        </Button>
                                    </Col>
                                    <Col xs="12" sm="12" md="auto" lg="auto" xl="auto" className="small-top-margin">
                                        <FacebookLogin
                                            appId="892186031146891"
                                            disableMobileRedirect={true}
                                            autoLoad={false}
                                            fields="name,email"
                                            callback={handleFacebookLogin}
                                            cssClass="btn btn-primary facebook-button"
                                            icon="fa-facebook"
                                        />
                                    </Col>
                                </Row>

                                <Button size="sm" variant="link" className="mt-2 mb-0" block
                                        href="https://skyduck.app/resetPassword">Forgot password?</Button>
                            </Form>
                            {error
                                ? <p className="my-invalid-feedback mt-3">
                                    {error.message}
                                </p>
                                : null
                            }
                        </Card.Body>
                    </Card>
                </Col>
            </div>
        </div>
    );
}

const useFormInput = initialValue => {
    const [value, setValue] = useState(initialValue);

    const handleChange = e => {
        setValue(e.target.value);
    }
    return {
        value,
        onChange: handleChange
    }
}

export default LoginScreen;